import useFormat from "hooks/useFormat";
import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { useColorScaleVDP, VerticalDotPlotAuto } from "../charts-motion";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_quality_fig_SANITATION";
import { datasets } from "../data/data_quality_fig_SANITATION_datasets";
import { mkGemEntityDecoder, ordLevel, useNamedEntitiesWithLevel } from "../domain";
import { useMedia } from "../hooks";
import { unsafeFromArray } from "../lib";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { Ar, identity, io, Ord } from "../prelude";
export * from "../data/data_quality_fig_SANITATION";
const yUnitLabel = defineMessage({
    id: "fig.quality.SANITATION.yUnitLabel",
    defaultMessage: "Schools with sanitation facilities"
});
export const Data = mkGemEntityDecoder([
    "ind_id",
    "level",
    "year"
], {
    value: io.number
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenMDown = !useMedia(breakpoints.m);
    const entityData = useNamedEntitiesWithLevel(data);
    const chartData = React.useMemo(()=>{
        return unsafeFromArray(Ar.sortBy([
            Ord.contramap((x)=>x.level)(ordLevel),
            Ord.contramap((x)=>x.value)(Ord.ordNumber)
        ])(entityData));
    }, [
        entityData
    ]);
    const getX = React.useCallback((x)=>x.entity_name, []);
    const getValue = React.useCallback((x)=>x.value, []);
    const getColor = React.useCallback((x)=>x.level_name, []);
    const getColorPalette = React.useCallback(()=>M.colorRanges.discrete, []);
    const formatY = useFormat(".0%");
    const [colorScale, colorLegendValues] = useColorScaleVDP({
        data: chartData,
        getColor,
        colorPalette: getColorPalette,
        formatColor: identity
    });
    return <VerticalDotPlotAuto height={screenMDown ? M.chartHeight.s : M.chartHeight.m} data={chartData} getX={getX} getValue={getValue} getColor={getColor} formatX={identity} formatValue={formatY} domainY={[
        0,
        1
    ]} colorScale={colorScale} colorLegendValues={colorLegendValues} showTooltip showLegend dotStyle={"small"} labelStyleX="none" yUnitLabel={intl.formatMessage(yUnitLabel)}/>;
};
export default withFigureIO({
    url: new URL("../data/data_quality_fig_SANITATION.json", import.meta.url).href,
    csv: new URL("../data/data_quality_fig_SANITATION.zip", import.meta.url).href,
    xlsx: new URL("../data/data_quality_fig_SANITATION.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    datasets
});
